import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ReactComponent as Logs } from '@styles/icons/logs.svg';
import React from 'react';

export const LogsIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={Logs} viewBox={'0 0 16 19'} />
);

export default LogsIcon;
